import { switchMap } from "rxjs/operators";
import { Component } from "@angular/core";
import { AuthService } from "../../services/auth.service";
import { Router, ActivatedRoute, Params } from "@angular/router";

@Component({
  selector: "login",
  template: `
    <div
      class="d-flex justify-content-center align-items-center min-vh-100 bg-light"
    >
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-6 col-lg-5 overlayParent">
            <div class="overlay" *ngIf="authService.redundancyPrevent == -1">
              <widget-spinner></widget-spinner>
            </div>

            <div class="card shadow-sm">
              <div class="card-body p-4">
                <h2 class="mb-1 text-center">Login</h2>
                <p class="text-muted text-center mb-4">
                  Sign in to your account
                </p>

                <!-- Username Input -->
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="fa fa-user"></i>
                    </span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="user"
                    placeholder="Username"
                  />
                </div>

                <!-- Password Input -->
                <div class="input-group mb-4">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="fa fa-lock"></i>
                    </span>
                  </div>
                  <input
                    [type]="showPassword ? 'text' : 'password'"
                    (keyup.enter)="login($event)"
                    class="form-control"
                    [(ngModel)]="password"
                    placeholder="Password"
                  />
                  <div class="input-group-append">
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      (click)="showPassword = !showPassword"
                    >
                      <i
                        class="fa"
                        [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"
                      ></i>
                    </button>
                  </div>
                </div>

                <!-- Login Button -->
                <div class="row">
                  <div class="col-12">
                    <button
                      type="button"
                      [disabled]="loading"
                      (click)="login($event)"
                      class="btn btn-primary btn-block"
                    >
                      Login
                    </button>
                  </div>
                </div>

                <!-- Error Message -->
                <div *ngIf="err" class="alert alert-danger mt-3 mb-0">
                  {{ msg }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [``],
})
export class LoginComponent {
  user: string = "";
  password: string = "";
  err: boolean = false;
  code: string = "";
  msg: string = "";
  loading: boolean = false;
  showPassword: boolean = false;
  //loggedIn;
  constructor(
    public authService: AuthService,
    public router: Router,
    public route: ActivatedRoute
  ) {
    //this.loggedIn = authService.isSignedIn;
  }

  login(event) {
    if (!/(.+)@(.+){2,}\.(.+){2,}/.test(this.user)) {
      this.msg = "Not an Email";
      this.err = true;
      return;
    }
    this.code = "";
    this.msg = "";
    this.err = false;
    this.loading = true;
    this.route.params
      .pipe(
        switchMap((params: Params) =>
          this.authService.loginWithCreds(this.user, this.password)
        )
      )
      .subscribe((data) => this.loginProcess(data));
    return false;
  }

  loginProcess(data) {
    this.loading = false;
    if (
      (data && data.code && data.code == "auth/wrong-password") ||
      data.code == "auth/user-not-found"
    ) {
      this.err = true;
      this.msg = "Invalid Credentials";
    }
    /*  //we have stopped caring about this At the moment, handeled elsewhere
    if(data.uid && data.uid.length > 5){
      this.router.navigateByUrl('portal/users/search');
    } else {
      this.code = data.code.substring(data.code.indexOf("/")+1);
      this.msg = data.msg;
      this.err = true;
    } */
  }

  logout(event) {
    this.authService.logout();
    return false;
  }
}
